const isAllowedTransform = process.env.REACT_APP_ALLOW_TRANSFORM || "";

export const isTransformationNotAllowed = () => {
  return isAllowedTransform.toLowerCase() === "no";
};
